import { getUrl } from '@js/common/getUrlByDomain'
import { SADB } from '@js/common/SADB'
import { UA } from '@js/common/UA'
import User from '@js/common/user'

export const API_URL = '/-'
export const HTTP_UNAUTHORIZED = 401

export interface ApiConnectionException {
  statusCode: number
  name: 'ApiConnectionException'
  payload: GenericPayload
}

export interface GenericPayload {
  [key: string]: string | number
}

export interface AdditionalHeaders {
  [key: string]: string
}

export interface ApiConnectionErrorHandler {
  (exception: ApiConnectionException): void
}

export class ApiConnectionException implements ApiConnectionException {
  constructor(public statusCode: number, payload: GenericPayload) {
    this.statusCode = statusCode
    this.name = 'ApiConnectionException'
    this.payload = payload
  }
}

function checkSubService() {
  return {
    isSADB: /^\/servicewelt-bauen/.test(window.location.pathname),
    isUA: /^\/(meinprojekt)|(mein-konto)/.test(window.location.pathname)
  }
}

function escortToLogin(exception: ApiConnectionException) {
  UA.doLogOut()

  if (!/anmelden/.test(window.location.href)) {
    window.location.href = `${getUrl('userAccount')()}anmelden/`
  } else {
    return exception
  }
}

function escortToSalesLogin(exception: ApiConnectionException) {
  SADB.doLogOut()

  if (!/anmelden/.test(window.location.href)) {
    window.location.href = '/servicewelt-bauen/anmelden/'
  } else {
    return exception
  }
}

export function setToken(headers: Headers) {
  const subService = checkSubService()

  if (subService.isSADB && SADB.isLoggedIn()) {
    headers.set('X-API-Token', `JWT ${SADB.getToken()}`)
  } else if (UA.isLoggedIn()) {
    headers.set('X-API-Token', `JWT ${UA.getToken()}`)
  }
}

export function createUrl(endpoint: string) {
  if (endpoint.indexOf('http') === 0) {
    return endpoint
  }

  const paramsPosition = endpoint.indexOf('?')
  let params = ''
  if (paramsPosition > -1) {
    params = endpoint.slice(paramsPosition)
  }
  endpoint = endpoint.replace(params, '')
  endpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
  endpoint = endpoint.endsWith('/') ? endpoint.slice(0, -1) : endpoint

  return `${API_URL}/${endpoint}${params}`
}

export function defaultUnauthorizedHandler(exception: ApiConnectionException) {
  const subService = checkSubService()
  if (subService.isUA) {
    escortToLogin(exception)
  } else if (subService.isSADB) {
    escortToSalesLogin(exception)
  } else {
    const userLocation = User.getLocation()
    UA.doLogOut()
    SADB.doLogOut()
    User.setLocation(userLocation)
  }
}
